const PartialBookLoading = () => {
    return <div className={"partials book"}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
}

export default PartialBookLoading;
